import { render, staticRenderFns } from "./CollectionCreator.vue?vue&type=template&id=7d4af27c&"
import script from "./CollectionCreator.vue?vue&type=script&lang=js&"
export * from "./CollectionCreator.vue?vue&type=script&lang=js&"
import style0 from "./CollectionCreator.vue?vue&type=style&index=0&id=7d4af27c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports